module.exports = __webpack_public_path__ + "img/event5.324fd8c5.png";